<style src="./fonts/iconic/css/material-design-iconic-font.min.css"></style>
<style src="./css/login.css"></style>

<template>
	<div class="loginContainer circular">
		<div class="loginWrapper">
			<form class="login100-form validate-form" @keypress="loginKeyPress">
				<span class="login100-form-logo">
					<img src="~@/assets/logo.jpeg" class="w-50" alt="logo">
				</span>

				<span class="login100-form-title py-5">
					Přihlášení
				</span>

				<div class="wrap-input100 validate-input" data-validate = "Zadejte uživatelské jméno">
					<input class="input100" type="text" name="username" v-model="username" placeholder="Uživatelské jméno" autocomplete="off">
					<span class="focus-input100"></span>
				</div>

				<div class="wrap-input100 validate-input" data-validate="Zadejte heslo">
					<input class="input100" type="password" name="pass" v-model="password" placeholder="Heslo">
					<span class="focus-input100"></span>
				</div>

				<div class="container-login100-form-btn mt-5">
					<b-button variant="light" class="loginBtn" @click="login">Přihlásit</b-button>
				</div>
			</form>

			<div class="text-center pt-5">
				<router-link class="bottomText mr-3" to="/forgottenPassword">
					Zapomněli jste heslo?
				</router-link>
			</div>
		</div>
		<div id="snackbar">{{msg}}</div>
	</div>
</template>

<script src="./js/login.js"></script>

<script>
import AuthService from '@/services/AuthService.js';
import vueFormHelper from '@/js/VueFormHelper.js';

export default {
	data() {
		return {
			username: '',
			password: '',
			msg: ''
		};
	},
	methods: {
		async login() {
			try {
				const credentials = {
					username: this.username,
					password: this.password
				};

				const response = await AuthService.login(credentials);
				this.msg = response.msg;
				const user = response.user;
				const permissions = response.permissions;

				const token = response.token;
				this.$store.dispatch('login', { token, user, permissions });
				this.$router.push('/overview');
			} catch (error) {
				vueFormHelper.showSnackbarMessage(this, error.response.data.msg, document);
			}
		},
		loginKeyPress: function(e) {
			if (e.keyCode == 13)
				this.login()
    }
	}
};
</script>